import React from "react";

const DataLoader = () => {
    return(
        <div className="data-loader">
            <img src='../../assets/images/loader.svg' alt="Loader"/>
        </div>
    );
}

export default DataLoader;